'use client';
import styled, { css } from 'styled-components';
import { colors } from '@/styles';

export const SchemaSummary = styled.div<{}>`
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* border: 1px solid ${colors.secondary.lightGray3}; */
  /* background: ${colors.secondary.lightGray1}; */
  /* display: flex;
  flex-direction: column;
  gap: 40px; */
`;

export const SchemaInfo = styled.div<{}>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* border: 1px dashed lime; */
  /* padding: 20px; */
  /* max-width: 400px; */
`;

const schemaSummariesGrid = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: masonry;
  gap: 50px;
`;

const schemaSummariesList = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  & > div:not(:last-child) {
    padding-bottom: 20px;
    border-bottom: 1px solid ${colors.secondary.lightGray3};
  }
`;

export const SchemaSummaries = styled.div<{ $display: 'grid' | 'list' }>`
  ${(props) => (props.$display === 'grid' ? schemaSummariesGrid : schemaSummariesList)};
`;

export const SchemaFields = styled.div<{}>`
  font-size: 12px;
  border-bottom: 1px solid ${colors.secondary.lightGray3};
  & > div {
    display: grid;
    grid-template-columns: 1fr auto;
    border-width: 1px 1px 0 1px;
    border-color: ${colors.secondary.lightGray3};
    border-style: solid;
    border-collapse: collapse;
    &.heading {
      background-color: ${colors.secondary.lightGray2};
      font-weight: bold;
    }
    & > div {
      display: table-cell;
      padding: 2px 5px;
    }
    &.toggle-row {
      display: block;
      text-align: center;

      padding: 3px 5px;
      a {
        cursor: pointer;
      }
    }
  }
`;

export const SchemaFiles = styled.div<{}>`
  & > div {
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;
